import React, { useContext, useEffect, useMemo, useState } from 'react';
import { AgendaContext } from '../../../contexts/AgendaContext';
// Mui components
import { Box, Typography } from '@mui/material';
import { DateField } from '@mui/x-date-pickers';
// DayJS
import dayjs from 'dayjs';
// Icons
import iconCircleInformation from '../../../assets/icons/icon_circle-information.svg';
import iconCircleWarningRed from '../../../assets/icons/icon_circle-warning-red.svg';

function PantallaFechaPublicacion({ errorInFechaPublicacion, setErrorInFechaPublicacion }) {
    const { solicitudProps, setSolicitudProps } = useContext(AgendaContext);
    const [fechaPublicacion, setFechaPublicacion] = useState(dayjs().add(1, 'day'));

    useEffect(() => {
        const unixTimestamp = dayjs(fechaPublicacion).unix();

        setSolicitudProps({ ...solicitudProps, fechaPublicacion: unixTimestamp });
    }, [])


    const errorMessage = useMemo(() => {
        switch (errorInFechaPublicacion) {
            case 'disablePast': {
                return <Box display="flex" alignItems="center" gap=".3rem" marginTop=".5rem">
                    <Box
                        component="img"
                        sx={{ width: "16px", height: "16px" }}
                        alt="img not found"
                        src={iconCircleWarningRed}
                    />
                    <Typography variant="legalM">La fecha no puede ser anterior al día de hoy.</Typography>
                </Box>;
            }

            case "maxDate": {
                return <Box display="flex" alignItems="center" gap=".3rem" marginTop=".5rem">
                    <Box
                        component="img"
                        sx={{ width: "16px", height: "16px" }}
                        alt="img not found"
                        src={iconCircleWarningRed}
                    />
                    <Typography variant="legalM">La fecha no puede ser posterior al lapso máximo de 30 días desde hoy.</Typography>
                </Box>;
            }
            case "invalidDate": {
                return <Box display="flex" alignItems="center" gap=".3rem" marginTop=".5rem">
                    <Box
                        component="img"
                        sx={{ width: "16px", height: "16px" }}
                        alt="img not found"
                        src={iconCircleWarningRed}
                    />
                    <Typography variant="legalM">La fecha que ingresaste no es válida.</Typography>
                </Box>;
            }

            default: {
                return '';
            }
        }
    }, [errorInFechaPublicacion]);



    const handleChangeFecha = (value) => {
        const unixTimestamp = dayjs(value).unix();
        setFechaPublicacion(value);
        setSolicitudProps({ ...solicitudProps, fechaPublicacion: unixTimestamp });
    };

    return (
        <Box sx={{ display: "flex", gap: "1.5rem", flexDirection: "column" }}>
            <Typography variant="h2">¿A partir de qué fecha te gustaría que se conecten los turnos en la agenda de OSDE?</Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
                <Box
                    component="img"
                    sx={{ width: "16px", height: "16px" }}
                    alt="img not found"
                    src={iconCircleInformation}
                />
                <Typography variant="bodyS">Esta fecha es de referencia. Una vez aprobada la solicitud te confirmaremos la fecha de publicación definitiva.</Typography>
            </Box>

            <DateField
                label="Fecha de publicación"
                onChange={handleChangeFecha}
                value={fechaPublicacion}
                variant="outlined"
                disablePast
                FormHelperTextProps={{ component: "div" }}
                InputProps={{ notched: false }}
                onError={(newError) => setErrorInFechaPublicacion(newError)}
                slotProps={{ textField: { InputLabelProps: { shrink: true, }, helperText: errorMessage, } }}
                sx={{ width: "60%", maxWidth: "452px" }}
                maxDate={dayjs().add(30, 'day')}
            // minDate={dayjs().add(1, 'day')}
            // defaultValue={dayjs().add(1, 'day')}
            />
        </Box>
    );
}

export default PantallaFechaPublicacion;